import React, { FC, useState } from 'react';
import { ReactComponent as BlacklistSettingsIcon } from 'assets/icons/blacklist.svg';
import { BaseModal, Button, Input } from '@cokitchen/cokitchen-components';

interface BlacklistSettingsModalType {
  show: boolean;
  onClose: () => void;
}

interface BlacklistSettingsFooterType {
  loading: boolean;
  onConfirm: () => void;
}

const BlacklistSettingsFooter: FC<BlacklistSettingsFooterType> = ({ onConfirm, loading }) => (
  <Button
    small
    color='primary'
    variant='block'
    className='mx-auto'
    loading={loading}
    onClick={onConfirm}>
    Confirm
  </Button>
);

const BlacklistSettingsModal: FC<BlacklistSettingsModalType> = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    no_of_rides: '',
    min_delivery_time: '',
    max_delivery_time: ''
  });
  const [loading] = useState<boolean>(false);
  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const sendDetails = async () => {
    console.log('sendDetails');
  };
  return (
    <BaseModal
      isOpen={show}
      title='Update Blacklist Settings'
      description='Manage blacklist settings and factors'
      titleIcon={<BlacklistSettingsIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={<BlacklistSettingsFooter loading={loading} onConfirm={sendDetails} />}>
      <div className=' space-y-3'>
        <Input
          name='no_of_rides'
          value={formData?.no_of_rides}
          onChange={handleChange}
          small
          label='No. of rides'
          placeholder='10000'
        />
        <Input
          name='min_delivery_time'
          value={formData?.min_delivery_time}
          onChange={handleChange}
          small
          label='Min. delivery time (mins)'
          placeholder='10 mins'
        />
        <Input
          name='max_delivery_time'
          value={formData?.max_delivery_time}
          onChange={handleChange}
          small
          label='Max. delivery time (mins)'
          placeholder='50 mins'
        />
      </div>
    </BaseModal>
  );
};

export default BlacklistSettingsModal;
